import { render } from "./BoqBuilder.vue?vue&type=template&id=726c2bb8&scoped=true"
import script from "./BoqBuilder.vue?vue&type=script&lang=js"
export * from "./BoqBuilder.vue?vue&type=script&lang=js"

import "./BoqBuilder.vue?vue&type=style&index=0&id=726c2bb8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726c2bb8"]])

export default __exports__